"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177218" id="instant-quote-form" className="relative w-full min-h-screen flex flex-col md:flex-row bg-background text-foreground overflow-hidden">
      {}
      <Separator orientation="vertical" className="hidden md:block absolute left-[60%] top-[100px] bottom-[100px] h-auto bg-primary/20 z-10" />

      {}
      <div className="w-full md:w-[60%] flex flex-col justify-center items-center p-8 py-20 md:p-16 lg:p-24 relative z-0">
        <div ref={textRef} className={`max-w-xl w-full flex flex-col transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="text-left w-full">
            <span className="text-primary uppercase tracking-widest text-sm font-semibold mb-6 block font-sans">
              Reserve Your Experience
            </span>
            <h2 className="text-foreground font-default text-5xl md:text-6xl lg:text-7xl leading-tight mb-12">
              Excellence in Motion
            </h2>
          </div>

          {}
          <div className="w-full flex justify-center mt-4">
            <Link to="/ReachUsPage">
              <Button variant="default" size="lg" className="rounded-none px-12 py-7 text-sm tracking-widest uppercase bg-transparent border border-primary text-primary hover:bg-gradient-to-r hover:from-primary hover:to-chart-5 hover:text-primary-foreground hover:shadow-[0_0_15px_rgba(212,175,55,0.3)] transition-all duration-300">
                Request Quote
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="w-full md:w-[40%] h-[60vh] md:h-auto relative bg-muted/20">
        <div ref={imgRef} className={`w-full h-full transition-all duration-1000 delay-300 ease-out ${isImgVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598014/img/radiant_skin_portrait.png" alt="Luxury chauffeur opening black sedan door in San Francisco" className="w-full h-full object-cover object-center grayscale hover:grayscale-0 transition-all duration-700" />
        </div>
      </div>
    </section>;
}